const packageJson = require('../../package.json');

const config = {
    version: packageJson.version,
    debugMode: true,
    adminDir: '/app',
    isCache: true
};

export default config;